import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { interval } from 'rxjs';

@Component({
  selector: 'app-steps-status',
  templateUrl: './steps-status.component.html',
  styleUrls: ['./steps-status.component.scss']
})
export class StepsStatusComponent implements OnInit {
  error: string;
  dashboardList: any;
  refreshToken: any;
  Type: any;

  constructor(public user:UserService) { }

  ngOnInit(): void {
    this.getDashboard();
 
  }
  getDashboard(){
    this.user.getDashboardData().pipe()
    .subscribe(
        data => {
       
          this.dashboardList=data.data.leads.stagesViews;
          this.Type = data.data.leads.type;
          sessionStorage.setItem('leadId',data.data.leads.leadId)
          sessionStorage.setItem('leadtype',data.data.leads.type)
          sessionStorage.setItem('commitionToOfLead',data.data.leads.commitionTo);
    //  this.languages=data.data.allLanguages;
    //  this.Salutation=data.data.salutation;
    //  this.personalinfo=data.data.leads;
    // this.fillData();
        },error=>{
          //  if(this.baseservice.handleError(error)){
             //handle Exception from Server 404,401
            if(error.status == 400 || error.status==417){
                this.error=error.error.data;
               
             }
             else{
               
               this.error="Something went wrong. Please check username and password.";
             }
        
            },()=>{});
   
  }

  
}
